import React from 'react';
import { CommonTeamMembers } from '../teams';

const UnassignedTeamMembersPage = (props) => (
  <CommonTeamMembers
    title="Unassigned team members"
    displayProgress={false}
    teamMemberFilter={(teamMember) => teamMember.teamIDs.length === 0}
    hideDaysRemaining={true}
    {...props} />
);

export default UnassignedTeamMembersPage;


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/unassigned-team-members.js